<template>
  <div class="side-catalogue-container">
    <ul>
      <div
        v-if="catalogueList.length > 0 && currentIndex !== -1"
        class="dot"
        :style="{ top: 12 + (currentIndex ? currentIndex : 0) * 30 + 'px' }"
      ></div>
      <li
        v-for="item in catalogueList"
        :key="item.id"
        :type="item.type"
        @click="handleClickLi(item.id)"
        :class="{ active: currentCataDomId === item.id }"
        :title="item.text"
      >
        - {{ item.text }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    catalogueList: {
      default: () => [],
      require: true,
      type: Array,
    },
    currentCataDomId: {
      default: "",
      type: String,
    },
  },
  computed: {
    currentIndex() {
      return this.catalogueList.findIndex(
        (item) => item.id === this.currentCataDomId
      );
    },
  },
  methods: {
    handleClickLi(id) {
      this.$emit("scrollTo", id);
    },
  },
};
</script>

<style lang="scss" scoped>
.side-catalogue-container {
  width: 16vw;
  box-sizing: border-box;
  user-select: none;
  ul {
    margin: 0;
    padding: 0;
    max-height: 600px;
    overflow-y: auto;
    overflow-x: auto;
    position: relative;
    padding: 0 10px;
    .dot {
      border: 3px solid;
      width: 3px;
      height: 3px;
      border-radius: 50%;
      color: #36f;
      position: absolute;
      left: 7px;
      transition: all 0.2s linear 0.3s;
      top: 12px;
    }
    li {
      color: #000;
      border-left: 2px solid #ddd;
      font-size: 13px;
      cursor: pointer;
      line-height: 30px;
      list-style: none;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    li[type="header1"] {
      padding-left: 0px;
    }
    li[type="header2"] {
      padding-left: 12px;
    }
    li[type="header3"] {
      padding-left: 24px;
    }
    li[type="header4"] {
      padding-left: 36px;
    }
    li.active {
      color: #36f !important;
    }
  }
}
</style>